import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FromPairsPipe } from 'ngx-pipes';
import { Aviso } from 'src/app/model/aviso';
import { AvisosService } from 'src/app/_services/avisos.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-form-avisos',
  templateUrl: './form-avisos.component.html',
  styleUrls: ['./form-avisos.component.css']
})
export class FormAvisosComponent implements OnInit {


formAviso: UntypedFormGroup = new UntypedFormGroup({
  titulo: new UntypedFormControl("", Validators.required),
  cuerpo: new UntypedFormControl("", Validators.required),
  file: new UntypedFormControl(""),
  visible: new UntypedFormControl(""),
  fileSource: new UntypedFormControl("")
})

API_URL: string = environment.API_URL;

   
  constructor(
    private _avisosService: AvisosService,
    private _router: Router,
  ) { }

  advise: Array<Aviso> = [];
  uploadSucesfully:boolean = false;
  adviseError : boolean = false;
  typeError:boolean = false;

  ngOnInit(): void {

  }


  onFileChange(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.formAviso.patchValue({
        fileSource: file
      });
    }
  }

  submit(){
    const formData = new FormData();

    formData.append('file', this.formAviso.value.fileSource);
    formData.append('titulo', this.formAviso.value.titulo)
    formData.append('cuerpo', this.formAviso.value.cuerpo)
    formData.append('visible', this.formAviso.value.visible)
    this._avisosService.saveAdvise(formData).subscribe({
      next: (data) => {

        this.formAviso.reset();
        this.uploadSucesfully = true;
        this.adviseError = false;
        this.typeError = false;
        setTimeout(() => { 
          this.reloadToMenuOption();
        }, 1000);
          
        setTimeout(() => {
          this._avisosService.getListAvisos();
        },400)
      },
      error: (err) => {
      
        if(err['error']['statusCode'] == 'INVALID_TYPE'){
          this.typeError = true;
          this.adviseError = false;
        }
        else{
          this.adviseError = true;
          this.typeError = false;
        }

      }
    })
  }

  scrollTop() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  reloadToMenuOption() {
    this._router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this._router.onSameUrlNavigation = 'reload';
    this.scrollTop()
    this._router.navigate(['/admin'], { queryParams: { action: 14 } });

  }
}
